/**
 * 环境配置文件入口
 * RippleX 项目 - 根据当前环境自动加载对应配置
 * 
 * 支持的环境:
 * - local: 本地开发环境 (npm run dev:local)
 * - dev: 开发服务器环境 (npm run dev:dev)
 * - prod: 生产环境 (npm run build)
 */

import localConfig from './local'
import devConfig from './dev'
import prodConfig from './prod'

// 获取当前环境变量
const env = process.env.NODE_ENV || 'local'

// 根据环境选择配置
const configs = {
  local: localConfig,
  development: localConfig,  // webpack development mode 默认使用 local
  dev: devConfig,
  production: prodConfig,
  prod: prodConfig
}

// 获取当前环境配置
const currentConfig = configs[env] || localConfig

// 导出默认配置对象
export default currentConfig

// 单独导出各个配置项，方便按需引入
export const {
  apiBaseURL,
  wsBaseURL,
  debug,
  verbose,
  mock,
  maxUploadSize,
  requestTimeout,
  enableRetry,
  titleSuffix,
  enableDevTools,
  publicPath,
  version
} = currentConfig

// 导出环境标识
export const currentEnv = currentConfig.env

// 导出是否是生产环境
export const isProduction = currentConfig.env === 'prod'

// 导出是否是开发环境
export const isDevelopment = currentConfig.env === 'dev' || currentConfig.env === 'local'

// 导出是否是本地环境
export const isLocal = currentConfig.env === 'local'

// 导出所有环境配置（供参考）
export { localConfig, devConfig, prodConfig }
